<template>
  <div style="text-align: left">
    <van-field
      v-if="false"
      v-model="name"
      label="姓名"
      placeholder="收货人姓名"
    />
    <van-field
      v-if="false"
      v-model="mobile"
      label="电话"
      placeholder="收货人电话"
    />
    <van-field
      v-model="area"
      label="地区"
      placeholder="选择省/市/区"
      readonly
      is-link
      @click="showArea = true"
    />
    <van-field
      ref="address"
      v-model="address"
      :label="fromNav ? '起点地址' : '详细地址'"
      clearable
      placeholder="街道门牌、楼层房间号等信息"
      @input="onChangeDetail"
      @focus="onFocus"
      @blur="onBlur"
    />
    <div
      v-show="searchResult.length > 0 && showSearchResult"
      class="search-result"
    >
      <div
        v-for="item in searchResult"
        :key="item.id"
        class="item"
        @click="onAddressItemClick(item)"
      >
        <van-icon
          name="location-o"
          size="14"
          style="margin-top: 6px"
        />
        <div class="info">
          <div
            style="font-size: 15px"
            v-html="setPartTextcolor(item.name)"
          />
          <span class="address">{{ item.address }}</span>
        </div>
      </div>
    </div>

    <div style="margin: 20px">
      <van-button
        block
        round
        color="#3D47B8"
        @click="onSave"
      >保存</van-button>
    </div>

    <van-popup
      v-model="showArea"
      round
      position="bottom"
    >
      <van-area
        ref="area"
        title=""
        :value="adCode"
        :area-list="areaList"
        @confirm="onConfirmArea"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Area, Popup, Toast } from 'vant'
import { areaList } from '@vant/area-data'
import axios from 'axios'
import util from '@/utils/util'
export default {
  components: {
    [Field.name]: Field,
    [Area.name]: Area,
    [Popup.name]: Popup
  },
  data() {
    return {
      showArea: false, // 显示省市区选择弹窗
      areaList, // 省市区数据
      searchResult: [], // poi搜索结果
      showSearchResult: false, // 显示poi搜索结果
      adCode: null, // 省市区代码
      provinceName: '', // 省
      cityName: '', // 市
      countyName: '', // 区
      name: '', // 姓名
      mobile: '', // 电话
      area: '', // 地区
      address: '', // 地址
      searchkeyword: '', // 地址栏输入
      fromNav: false,
      poiLocation: null, // poi点坐标"lng,lat"
      location: null, // 用户当前坐标
      navEvent: null, // 1:起点修改 2:终点修改
      originAddress:''//未加星号的原始地址
    }
  },
  created() {
    // 判断是从哪个页面跳转来的 nav:原生导航页面--修改起点
    const from = util.getUrlKey('from')
    if (from && from === 'nav') {
      this.fromNav = true
      this.navEvent = util.getUrlKey('event')
    }
  },
  mounted() {
    // 维护常用地址
    if (!this.fromNav) {
      this.getAddress()
    }
    this.getAppLocation()
  },
  methods: {
    onSave() {
      const that = this
      if (!that.cityName && !that.fromNav) {
        Toast('请选择地区')
        return
      }
      if (!that.address) {
        Toast('请输入详细地址')
        return
      }
      let paramAddress = that.address
      if(that.address == '******'){
        paramAddress = that.originAddress
      }
      if (!that.poiLocation) {
        Toast('输入地址有误')
        return
      }
      this.$ckEvent.add('init', function() {
        if (that.fromNav) {
          let lng
          let lat
          if (that.poiLocation && that.poiLocation.includes(',')) {
            const arr = that.poiLocation.split(',')
            if (arr.length === 2) {
              lng = arr[0]
              lat = arr[1]
            }
          }
          if (that.navEvent === '1') {
            window.hdk.device.saveStartPoint(lng, lat, paramAddress)
          } else if (that.navEvent === '2') {
            window.hdk.device.saveEndPoint(lng, lat, paramAddress)
          }
        } else {
          window.hdk.device.saveUserAddress(that.cityName, paramAddress)
        }
      })
    },
    getAddress() {
      const that = this
      this.$ckEvent.add('init', function() {
        window.hdk.device.getUserAddress(function(status, result) {
          if (status === 'SUCCESS') {
            if (!result) {
              return
            }
            that.provinceName = result.poiProvince
            that.cityName = result.poiCity
            that.countyName = result.poiDistrict
            // that.address = result.poiAddress
            that.address = "******"
            that.originAddress = result.poiAddress
            that.adCode = result.districtCode
            if (that.provinceName && that.cityName && that.countyName) {
              that.area = `${that.provinceName}/${that.cityName}/${that.countyName}`
            }
          }
        })
      })
    },
    getAppLocation() {
      const that = this
      this.$ckEvent.add('init', function() {
        window.hdk.device.getAppLocation(function(status, result) {
          if (status === 'SUCCESS') {
            if (!result) {
              return
            }
            const lng = result.longitude
            const lat = result.latitude
            // 选择地址时需要设置当前定位信息
            if (that.fromNav) {
              that.provinceName = result.province
              that.cityName = result.city
              that.countyName = result.district
              that.address = result.poiName
              that.adCode = result.adCode
              if (that.provinceName && that.cityName && that.countyName) {
                that.area = `${that.provinceName}/${that.cityName}/${that.countyName}`
              }
            }
            if (lng && lat) {
              that.poiLocation = `${lng},${lat}`
              that.location = `${lng},${lat}`
            }
          }
        })
      })
    },
    // 逆地理编码
    getAddressFromLocation() {
      const url = `https://restapi.amap.com/v3/geocode/regeo?key=6657ce532af7e1ba869148dff59e8b35&extensions=all&location=${this.location}`
      axios.get(url).then(res => {
        console.log(res)
        if (res.data && res.data.regeocode) {
          // 展示poi列表
          if (res.data.regeocode.pois) {
            this.searchResult = res.data.regeocode.pois
            this.showSearchResult = true
            this.address = this.searchResult[0].name
            this.poiLocation = this.searchResult[0].location
          }
          // 设置为当前省市区
          if (res.data.regeocode.addressComponent) {
            const addressComponent = res.data.regeocode.addressComponent
            this.provinceName = addressComponent.province
            this.cityName = addressComponent.city
            this.countyName = addressComponent.district
            this.adCode = addressComponent.adcode
            // 这里要调用area组件方法重置一下 不然会有默认选中的bug
            if (this.$refs['area']) {
              this.$refs['area'].reset(this.adCode)
            }
            if (this.provinceName && this.cityName && this.countyName) {
              this.area = `${this.provinceName}/${this.cityName}/${this.countyName}`
            }
          }
        }
      })
    },

    onConfirmArea(val) {
      console.log(val)
      this.showArea = false
      if (val && val.length === 3) {
        const provinceData = val[0]
        if (provinceData && provinceData.name) {
          this.provinceName = provinceData.name
        }
        const cityData = val[1]
        if (cityData && cityData.name) {
          if (this.cityName !== cityData.name) {
            this.address = ''
            this.searchResult = []
            this.showSearchResult = false
          }
          this.cityName = cityData.name
        }
        const countyData = val[2]
        if (countyData && countyData.name) {
          this.countyName = countyData.name
        }
      }
      this.area = `${this.provinceName}/${this.cityName}/${this.countyName}`
    },
    onChangeDetail(val) {
      this.searchkeyword = val
      this.poiLocation = null
      if (val) {
        this.getPoiData(val)
      } else {
        this.searchResult = []
        this.showSearchResult = false
      }
    },
    getPoiData(val) {
      let url = ''
      if (this.cityName) {
        url = `https://restapi.amap.com/v5/place/text?key=6657ce532af7e1ba869148dff59e8b35&keywords=${val}&region=${this.cityName}&city_limit=true`
      } else {
        url = `https://restapi.amap.com/v5/place/text?key=6657ce532af7e1ba869148dff59e8b35&keywords=${val}`
      }
      axios
        .get(url)
        .then(res => {
          console.log(res)
          if (res.data && res.data.pois) {
            this.searchResult = res.data.pois
            this.showSearchResult = true
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    onAddressItemClick(item) {
      this.address = item.name
      this.poiLocation = item.location
      this.showSearchResult = false
    },
    onFocus() {
      this.showSearchResult = true
    },
    onBlur() {},
    onLocationClick() {
      // 坐标转地址
      this.getAddressFromLocation()
    },
    setPartTextcolor(text) {
      const replaceReg = new RegExp(this.searchkeyword, 'g') // 定义匹配规则
      const replaceString =
        '<span style="color:#f00;">' + this.searchkeyword + '</span>'
      text = text.replace(replaceReg, replaceString)
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.search-result {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #f5f5f5;
  margin: 0 12px;
  .item {
    display: flex;
    padding: 12px;
    .info {
      margin-left: 4px;
      display: flex;
      flex-direction: column;
      .address {
        font-size: 12px;
        color: #888888;
        margin-top: 2px;
      }
    }
  }
}
</style>
